// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3rhuf","savePackageButton":"ClientWallet_savePackageButton__2GBWy"};